var initialSlide = 0;
var music = new Howl({
  src: ["//download4.qcplay.com/mp4/checkerboard.mp3"],
  autoplay: true,
  loop: true,
  onplay: function () {
    $(".music-btn").addClass("music-on"); //开始播放样式
  },
});
var musicCount = 0;

var initialSlide = 0;

var obj = {
  index: function () {
    function getRequest() {
      var query = window.location.search;
      if (query.indexOf("?") != -1) {
        var str = query.substring(1);
        var strs = str.split("=");
        if (strs[1] == 1) {
          initialSlide = 1;
        } else if (strs[1] == 2) {
          initialSlide = 2;
        } else if (strs[1] == 3) {
          initialSlide = 3;
        } else if (strs[1] == 4) {
          initialSlide = 4;
        } else if (strs[1] == 5) {
          initialSlide = 5;
        } else if (strs[1] == 6) {
          initialSlide = 6;
        }
      }
    }
    getRequest(); //二级页面导航栏跳转
    this.preloading(); // 预加载
    this.indexBind(); // 绑定
    this.sceneParallax(); //首屏景深
    this.swiper(); //swiper
    this.countdown(); // 首页倒计时
    this.countNum(); //阿里云埋点
    this.calendarInit();
  },
  sceneParallax: function () {
    var scene = document.getElementById("scene");
    var parallax = new Parallax(scene);
  },
  // 图片资源预加载
  preloading: function () {
    //图片预加载
    var queue = new createjs.LoadQueue();
    queue.on(
      "progress",
      function (e) {
        //加载中的进度
      },
      this,
    );
    queue.on(
      "complete",
      function (e) {
        //加载完成执行操作
        var index = layer.load(2, { shade: [0.1, "#fff"] });
        layer.close(index);
        $(".preloading").addClass("preloading-ani").fadeOut(1000);
        $(".index").removeClass("loading");

        setTimeout(function () {
          $(".preloading").remove();
        }, 2000);
      },
      this,
    );
    queue.loadManifest([
      //加载图片，不包括后台的
      "/promo/images/pc/index_bg-9751fa40c8.png",
      "/promo/images/pc/main_title-7e4fdd0028.png",
      "/promo/images/pc/logo_img-30381ea1bc.png",
      "/promo/images/pc/app_store-1ae0ef2e9d.png",
      "/promo/images/pc/google_btn-2869e08b42.png",
      "/promo/images/pc/home_btn-2b338489af.png",
      "/promo/images/pc/music_on-077ac5eaff.png",
      "/promo/images/pc/nav/nav_bg_orange-cdcfd6b636.png",
      "/promo/images/pc/nav/nav_btn_orange-df171ebe29.png",
      "/promo/images/pc/nav/nav_text_orange-11180a69ca.png",
      "/promo/images/pc/nav/nav_num_green-b266081dfe.png",
    ]);
  },
  loading: function () {
    var index = layer.load(2, { shade: [0.1, "#fff"] });
    setTimeout(function () {
      layer.close(index);
      $(".index").removeClass("loading");
    }, 200);
  },
  // 首页绑定相关
  indexBind: function () {
    $(".monitor-btn").on("click", function () {
      var mon_btn = $(this).attr("data-event");
      obj.countNum(mon_btn);
    });

    // 点击音乐
    $(".music-btn").click(function (event) {
      if (musicCount == 1) {
        music.play();
        $(this).removeClass("ani-pause"); //去除暂时播放样式
        $(this).addClass("music-on"); //开始播放样式
        musicCount = 0;
      } else {
        $(this).addClass("ani-pause"); //添加暂时播放样式
        music.pause();
        musicCount = 1;
      }
    });

    // 关闭弹窗
    $(".popup").on("click", function (event) {
      $(".popup").fadeOut();
    });

    var user_match = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
    user_match
      ? $(".download-btn").addClass("app-btn")
      : $(".download-btn").addClass("google-btn");

    var iosUrl = "https://apps.apple.com/jp/app/id6462012491";
    var googleUrl =
      "https://play.google.com/store/apps/details?id=com.hortor.fejsf.qc";
    $(".app-btn , .App_Store").attr("href", iosUrl);
    $(".google-btn , .Google_Play").attr("href", googleUrl);

    // 跳转官网主页按钮
    var homeUrl = "https://fgg.qcplay.co.jp/official/index.html?promo=true";
    $(".home-btn").attr("href", homeUrl);
  },
  swiper: function () {
    var swiperH = new Swiper(".swiper-container-h", {
      direction: "vertical",
      resistanceRatio: 0,
      mousewheelControl: true,
      spaceBetween: 0,
      initialSlide: initialSlide,
      slidesPerView: "auto",
      onInit: function (swiper) {
        swiperAnimateCache(swiper); //隐藏动画元素
        swiperAnimate(swiper); //初始化完成开始动画
        $(".go_top").on("click", function () {
          swiperH.slideTo(0, 1000, true);
        });
      },
      onSlideChangeStart: function (swiper) {
        swiperAnimate(swiper);
        var index = swiper.activeIndex;
        var colors = ["orange", "purple", "green", "blue", "pink", "cheng"];
        $(".bottom-nav").removeClass(colors.join(" ")).addClass(colors[index]);
      },
      onSlideChangeEnd: function (swiper) {
        swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
      },
      onTouchEnd: function (swiper) {
        swiperAnimate(swiper);
      },
    });

    // 1. 初始化底部的头像滚动 (PC版)
    var thumbSwiper = new Swiper(".swiper-container-thumbs", {
      slidesPerView: 5, // 依然只显示 5 个
      spaceBetween: 10, // 固定间距 10px
      allowTouchMove: true,
      observer: true,
      observeParents: true,
    });

    // 2. 初始化顶部大图滚动
    var roleSwiper = new Swiper(".swiper-container-role", {
      loop: true,
      prevButton: ".left_arrow",
      nextButton: ".right_arrow",
      pagination: ".pagination-box",
      paginationClickable: true,
      onSlideChangeStart: function (swiper) {
        var realIdx = swiper.realIndex;

        // A. 更新底部选中样式
        $(".icon_item")
          .eq(realIdx)
          .addClass("select")
          .siblings()
          .removeClass("select");

        // B. 联动底部滚动
        if (realIdx >= 3) {
          thumbSwiper.slideTo(realIdx - 2);
        } else {
          thumbSwiper.slideTo(0);
        }
      },
    });

    // 3. 蓝色小箭头：控制角色切换
    $(".thumb_next").on("click", function () {
      roleSwiper.slideNext();
    });
    $(".thumb_prev").on("click", function () {
      roleSwiper.slidePrev();
    });

    // 4. 点击头像跳转
    $(".icon_item").on("click", function () {
      var i = $(this).index();
      roleSwiper.slideTo(i + 1);
    });

    var thumbSwiper2 = new Swiper(".swiper-container-thumbs2", {
      slidesPerView: 5, // 依然只显示 5 个
      spaceBetween: 10, // 固定间距 10px
      allowTouchMove: true,
      observer: true,
      observeParents: true,
    });

    // 2. 初始化顶部大图滚动
    var roleSwiper2 = new Swiper(".swiper-container-role2", {
      loop: true,
      prevButton: ".left_arrow_2",
      nextButton: ".right_arrow_2",
      pagination: ".pagination-box-2",
      paginationClickable: true,
      onSlideChangeStart: function (swiper) {
        var realIdx = swiper.realIndex;

        // A. 更新底部选中样式
        $(".icon_item2")
          .eq(realIdx)
          .addClass("select")
          .siblings()
          .removeClass("select");

        // B. 联动底部滚动
        if (realIdx >= 3) {
          thumbSwiper2.slideTo(realIdx - 2);
        } else {
          thumbSwiper2.slideTo(0);
        }
      },
    });

    // 3. 蓝色小箭头：控制角色切换
    $(".thumb_next_2").on("click", function () {
      roleSwiper2.slideNext();
    });
    $(".thumb_prev_2").on("click", function () {
      roleSwiper2.slidePrev();
    });

    // 4. 点击头像跳转
    $(".icon_item2").on("click", function () {
      var i = $(this).index();
      roleSwiper2.slideTo(i + 1);
    });

    var cardSwiper = new Swiper(".swiper-container-decoration", {
      loop: true,
      pagination: ".pagination-box-3",
      paginationClickable: true,
      autoplay: 2000,
      autoplayDisableOnInteraction: false,
      grabCursor: true,
      centeredSlides: true,
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      slidesPerView: "auto",
      spaceBetween: 100,
      onInit: function (swiper) {
        swiper.stopAutoplay();
      },
    });

    function toggleSlogan(realIndex) {
      const s1 = document.querySelector(".slogan-01");
      const s2 = document.querySelector(".slogan-02");
      if (!s1 || !s2) return;

      // 需求：index=0 显示 slogan-02；index=1 显示 slogan-01
      if (realIndex === 0) {
        s1.classList.add("active-hide");
        s2.classList.remove("active-hide");
      } else if (realIndex === 1) {
        s1.classList.remove("active-hide");
        s2.classList.add("active-hide");
      } else {
        // 其他页默认显示 01（你也可以改成显示 02）
        s1.classList.remove("active-hide");
        s2.classList.add("active-hide");
      }
    }

    var setSwiper = new Swiper(".swiper-container-set", {
      loop: true,
      pagination: ".pagination-box-4",
      paginationClickable: true,
      autoplay: 2000,
      autoplayDisableOnInteraction: false,
      grabCursor: true,
      centeredSlides: true,
      nextButton: ".swiper-button-next-2",
      prevButton: ".swiper-button-prev-2",
      slidesPerView: "auto",
      spaceBetween: 150,
      onInit: function (swiper) {
        swiper.stopAutoplay();
        toggleSlogan(swiper.realIndex); // 初始化先切一次
      },

      onSlideChangeStart: function (swiper) {
        toggleSlogan(swiper.realIndex); // 初始化先切一次
      },
    });

    var rlSwiper = new Swiper(".swiper-container-rl", {
      loop: true,
      pagination: ".pagination-box-5",
      paginationClickable: true,
      autoplay: 2000,
      autoplayDisableOnInteraction: false,
      grabCursor: true,
      centeredSlides: true,
      nextButton: ".swiper-button-next-3",
      prevButton: ".swiper-button-prev-3",
      slidesPerView: "auto",
      spaceBetween: 150,
      onInit: function (swiper) {
        swiper.stopAutoplay();
      },
    });
  },
  // 首页倒计时
  countdown: function () {
    // 开启时间
    var targetDates = [
      new Date("2026-01-28 00:00:00").getTime(), //4
      new Date("2026-01-29 00:00:00").getTime(), //3
      new Date("2026-01-30 00:00:00").getTime(), //2
      new Date("2026-01-31 00:00:00").getTime(), //1
      new Date("2026-02-01 00:00:00").getTime(), //0
    ];

    // 检查当前时间并显示相应的倒计时
    function checkDateAndShowCountdown() {
      // 获取当前时间
      var now = new Date().getTime();
      console.log("now", now);
      console.log("now3333", targetDates[0]);
      console.log("bb", now < targetDates[0]);
      // 检查是否在所有目标日期之前
      if (now < targetDates[0]) {
        $(".bottom-nav .text").remove();
        $(".bottom-nav .countdown").remove();
        $(".bottom-nav .download-btn").remove();
        return;
      }

      for (var i = 0; i < targetDates.length; i++) {
        if (now < targetDates[i]) {
          var remainingDays = targetDates.length - i;
          $(".countdown").addClass(`countdown-${remainingDays}`);
          return;
        }
      }

      // 如果超过了所有目标日期
      $(".text-box .text").addClass("online");
      $(".text-box .countdown ").remove();
    }

    // 启动检查
    checkDateAndShowCountdown();
  },
  calendarInit: function () {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    var isMobile = isiOS || isAndroid;

    // 3. 按钮点击逻辑
    $(".yuyue-btn")
      .off("click.calendar")
      .on("click.calendar", function () {
        // --- 场景 A: PC端 ---
        if (!isMobile) {
          layer.msg(
            "重要なイベントのワンタップで予約を行うには、ぜひスマートフォンで本サイトにアクセスしてください！",
          );
          return;
        }
      });
  },
  // 阿里云埋点
  countNum: function (data) {
    setTimeout(() => {
      try {
        __bl.sum(data);
      } catch (e) {
        console.log(e);
      }
    }, 500);
  },
};
